import React from "react";

function FormField({ icon, label, type = "text", placeholder, value, onChange, required }) {
  return (
    <div className="form-field">
      <label className="form-label">
        {label}
        {required && <span className="form-required">*</span>}
      </label>
      <div className="form-input-wrap">
        <span className="form-icon">{icon}</span>
        <input
          type={type}
          className="form-input"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
        />
      </div>
    </div>
  );
}

function PassengerForm({ passenger, setPassenger }) {
  const update = (field) => (e) =>
    setPassenger((prev) => ({ ...prev, [field]: e.target.value }));

  const isComplete = passenger.name && passenger.email;
  const completeness = [passenger.name, passenger.email, passenger.phone].filter(Boolean).length;

  return (
    <div className="pax-form-card">
      <div className="card-header">
        <div className="card-header-left">
          <div className="card-icon card-icon--blue">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
            </svg>
          </div>
          <div>
            <div className="card-title">Passenger Details</div>
            <div className="card-sub">Fill in traveller information</div>
          </div>
        </div>
        {isComplete && (
          <div className="complete-badge">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
            Ready
          </div>
        )}
      </div>

      {/* Progress */}
      <div className="form-progress">
        <div className="form-progress-bar" style={{ width: `${(completeness / 3) * 100}%` }} />
      </div>

      <div className="form-fields">
        <FormField
          required
          label="Full Name"
          placeholder="e.g. Wuna Akhilesh"
          value={passenger.name}
          onChange={update("name")}
          icon={
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
            </svg>
          }
        />
        <FormField
          label="Email Address"
          type="email"
          placeholder="you@example.com"
          value={passenger.email}
          onChange={update("email")}
          icon={
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
              <polyline points="22,6 12,13 2,6"/>
            </svg>
          }
        />
        <FormField
          label="Phone Number"
          type="tel"
          placeholder="+91 98765 43210"
          value={passenger.phone}
          onChange={update("phone")}
          icon={
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 11a19.79 19.79 0 01-3-8.63A2 2 0 012 .18h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
            </svg>
          }
        />
      </div>
    </div>
  );
}

export default PassengerForm;